import styled, { css } from 'styled-components';

import { colors, radius } from '../../styles/tokens';

interface ContainerProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const Container = styled.div`
  span {
    font-size: 12px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${colors.onSurfaceVariant};
    margin-left: 4px;
    line-height: 20px;
  }
`;

export const ContainerInput = styled.div<ContainerProps>`
  display: flex;
  width: calc(100% - 24px);
  height: 170px;

  padding: 12px;

  transition: border-color 0.2s;

  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant};

  background-color: ${colors.surfaceContainerHigh};

  color: ${colors.onSurface};

  font-size: 16px;
  font-weight: 400;

  ${props =>
    props.isErrored &&
    css`
      border-color: ${colors.error};
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: ${colors.primary};
    `}
`;

export const Input = styled.textarea`
  display: flex;
  flex: 1;
  padding: 0;
  width: 100%;
  border: none;
  background-color: transparent;
  resize: none;

  color: ${colors.onSurface};

  font-size: 16px;
  font-weight: 400;

  &::placeholder {
    color: ${colors.onSurfaceVariant};
  }
`;
